var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        title: "配置监测项目任务",
        okText: _vm.step === 3 ? "关闭" : "下一步",
        cancelText: "取消",
        width: "1000px",
        visible: _vm.visible,
        "confirm-loading": _vm.confirmLoading,
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
    },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.spinning } },
        [
          _c(
            "a-form-model",
            {
              ref: "ruleForm",
              attrs: {
                model: _vm.formState,
                rules: _vm.rules,
                "label-col": { span: 8 },
                "wrapper-col": { span: 16 },
              },
            },
            [
              _vm.step === 0 || _vm.step === 3
                ? _c(
                    "a-row",
                    [
                      _c(
                        "a-col",
                        { attrs: { span: "12" } },
                        [
                          _c(
                            "a-form-model-item",
                            { attrs: { label: "项目名称", prop: "name" } },
                            [
                              _c("a-input", {
                                attrs: { disabled: true },
                                model: {
                                  value: _vm.formState.name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formState, "name", $$v)
                                  },
                                  expression: "formState.name",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: "12" } },
                        [
                          _c(
                            "a-form-model-item",
                            { attrs: { label: "监测品类", prop: "hangye" } },
                            [
                              _c("a-input", {
                                attrs: { disabled: true },
                                model: {
                                  value: _vm.formState.hangye,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formState, "hangye", $$v)
                                  },
                                  expression: "formState.hangye",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.step === 0 || _vm.step === 3
                ? _c(
                    "a-row",
                    [
                      _c(
                        "a-col",
                        { attrs: { span: "12" } },
                        [
                          _c(
                            "a-form-model-item",
                            { attrs: { label: "所属方案", prop: "plan.name" } },
                            [
                              _c("a-input", {
                                attrs: { disabled: true },
                                model: {
                                  value: _vm.formState.plan.name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formState.plan, "name", $$v)
                                  },
                                  expression: "formState.plan.name",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: "12" } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: "抽检任务类型",
                                prop: "taskType",
                              },
                            },
                            [
                              _c("a-ext-local-dic-select", {
                                attrs: {
                                  disabled: _vm.disabledFB,
                                  "dic-key": "MonitProjectType",
                                },
                                model: {
                                  value: _vm.formState.taskType,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formState, "taskType", $$v)
                                  },
                                  expression: "formState.taskType",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.step === 0 || _vm.step === 3
                ? _c(
                    "a-row",
                    [
                      _c(
                        "a-col",
                        { attrs: { span: "12" } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: "监测项目实施时间",
                                prop: "startDate",
                              },
                            },
                            [
                              _c("a-ext-data-picker", {
                                attrs: { disabled: _vm.disabledFB },
                                model: {
                                  value: _vm.formState.startDate,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formState, "startDate", $$v)
                                  },
                                  expression: "formState.startDate",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: "12" } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                "label-col": { span: 0 },
                                "wrapper-col": { span: 20 },
                                prop: "endDate",
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "inline-block",
                                    width: "100px",
                                  },
                                },
                                [_vm._v("至")]
                              ),
                              _c("a-ext-data-picker", {
                                attrs: { disabled: _vm.disabledFB },
                                model: {
                                  value: _vm.formState.endDate,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formState, "endDate", $$v)
                                  },
                                  expression: "formState.endDate",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.step === 0 || _vm.step === 3
                ? _c(
                    "a-row",
                    [
                      _c(
                        "a-col",
                        { attrs: { span: "24" } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                labelCol: { span: 4 },
                                wrapperCol: { span: 20 },
                                label: "监测环节",
                                prop: "monitLink",
                              },
                            },
                            [
                              _c("a-ext-monit-link-check-box", {
                                attrs: { disabled: _vm.disabledFB },
                                model: {
                                  value: _vm.formState.monitLink,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formState, "monitLink", $$v)
                                  },
                                  expression: "formState.monitLink",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.step === 0 || _vm.step === 3
                ? _c(
                    "a-row",
                    [
                      _c(
                        "a-col",
                        { attrs: { span: "12" } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                labelCol: { span: 8 },
                                wrapperCol: { span: 16 },
                                label: "抽样单模板选择",
                                prop: "pickFormId",
                              },
                            },
                            [
                              _c("a-ext-pick-sheet-select", {
                                attrs: { disabled: _vm.disabledFB },
                                model: {
                                  value: _vm.formState.pickFormId,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formState, "pickFormId", $$v)
                                  },
                                  expression: "formState.pickFormId",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: "12" } },
                        [
                          !_vm.disabledFB
                            ? _c(
                                "a-button",
                                {
                                  staticStyle: { "margin-top": "4px" },
                                  attrs: { type: "primary" },
                                },
                                [_vm._v("添加新抽样单模板")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.step === 0 || _vm.step === 3
                ? _c(
                    "a-row",
                    [
                      _c(
                        "a-col",
                        { attrs: { span: "24" } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                labelCol: { span: 4 },
                                wrapperCol: { span: 20 },
                                label: "附件",
                                prop: "planFile",
                              },
                            },
                            [
                              _c("a-ext-upload", {
                                attrs: { disabled: true },
                                model: {
                                  value: _vm.formState.commonFile,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formState, "commonFile", $$v)
                                  },
                                  expression: "formState.commonFile",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.step === 1 || _vm.step === 3
                ? _c(
                    "a-row",
                    [
                      _c(
                        "a-col",
                        { attrs: { span: "24" } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                labelCol: { span: 0 },
                                wrapperCol: { span: 24 },
                                prop: "monitTaskList",
                              },
                            },
                            [
                              _vm.formState.plan.level === "省级"
                                ? _c("a-ext-check-target-picker-province", {
                                    attrs: { disabled: _vm.disabledFB },
                                    model: {
                                      value: _vm.formState.monitTaskList,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formState,
                                          "monitTaskList",
                                          $$v
                                        )
                                      },
                                      expression: "formState.monitTaskList",
                                    },
                                  })
                                : _vm._e(),
                              _vm.formState.plan.level === "市级"
                                ? _c("a-ext-check-target-picker-city", {
                                    attrs: { disabled: _vm.disabledFB },
                                    model: {
                                      value: _vm.formState.monitTaskList,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formState,
                                          "monitTaskList",
                                          $$v
                                        )
                                      },
                                      expression: "formState.monitTaskList",
                                    },
                                  })
                                : _vm._e(),
                              _vm.formState.plan.level === "区县级" &&
                              !_vm.confirmLoading
                                ? _c("a-ext-check-target-picker-county", {
                                    attrs: { disabled: _vm.disabledFB },
                                    model: {
                                      value: _vm.formState.monitTaskList,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formState,
                                          "monitTaskList",
                                          $$v
                                        )
                                      },
                                      expression: "formState.monitTaskList",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.step === 2 || _vm.step === 3
                ? _c(
                    "a-row",
                    [
                      _c(
                        "a-col",
                        { attrs: { span: "24" } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                labelCol: { span: 0 },
                                wrapperCol: { span: 24 },
                                prop: "monitProduceList",
                              },
                            },
                            [
                              _vm.formState.taskType === "抽样检测任务"
                                ? _c("a-ext-pin-zhong-and-bad-select", {
                                    attrs: { disabled: _vm.disabledFB },
                                    model: {
                                      value: _vm.formState.monitProduceList,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formState,
                                          "monitProduceList",
                                          $$v
                                        )
                                      },
                                      expression: "formState.monitProduceList",
                                    },
                                  })
                                : _vm._e(),
                              _vm.formState.taskType === "抽样任务"
                                ? _c("a-ext-pin-zhong-select", {
                                    attrs: { disabled: _vm.disabledFB },
                                    model: {
                                      value: _vm.formState.monitProduceList,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formState,
                                          "monitProduceList",
                                          $$v
                                        )
                                      },
                                      expression: "formState.monitProduceList",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }